<script context="module">
	let idCounter = 0;
</script>

<script>
	export let type = "text";
	export let options = [];
	export let error = false;
	export let errorText = "";
	export let defaultOption = "";
	export let disableFirstOption = false;
	export let defaultValue = "";
	export let value = "";
	export let onChange = () => {};
	export let disabled = false;
	export let id = "";
	export let name = "";
	export let style = "";
	export let classes = "";
	export let label = "";

	$: optionsSelect = options || [];

	const uid = `custom-select-${idCounter++}`;
	$: selectId = id || uid;
	$: labelText = label || defaultOption || name || id;
</script>

<div>
	{#if labelText}
		<label for={selectId} class="visually-hidden">{labelText}</label>
	{/if}
	<select
		{type}
		class={`form-select getgo select ${error ? "danger" : ""} ` + classes}
		id={selectId}
		bind:value
		on:change={onChange}
		{disabled}
		style={value === ""
			? "color: var(--fds-on-surface-variant) "
			: " " + style}
		data-testid="select-reason"
	>
		{#if defaultOption}
			<option
				value={defaultValue || ""}
				disabled={disableFirstOption}
				selected>{defaultOption}</option
			>
		{/if}

		{#each optionsSelect as option}
			<option value={option.id || option.value}
				>{option.name || option.label}</option
			>
		{/each}
	</select>
	{#if error}
		<small class="error-text">{errorText}</small>
	{/if}
</div>
